// plugins/pinia.ts
import { createPinia } from "pinia";

export default defineNuxtPlugin((nuxtApp) => {
	const pinia = createPinia();
	nuxtApp.vueApp.use(pinia);
	nuxtApp.pinia = pinia; // optional: add to Nuxt app context
});
